import { env } from '../env';
import Grid from "@mui/material/Grid";
import { CircularProgress, Skeleton, Typography } from "@mui/material";
import { PractitionerCard, EarlyDate, ChoiceHistory } from "../component";
import { useState } from "react";
import { useEffect } from "react";

function Practitioner({ setPage, page }) {
  const [practitioners, setPractitioners] = useState();

  useEffect(() => {
      console.log(page.place);
      const request = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
          body: JSON.stringify({
              LK: env.REACT_APP_LICENCE_KEY,
              ENVID: env.REACT_APP_ENV_ID,
              PlaceID: page.place.ID,
              AppointmentTypeID: page.motif.ID
          })
      };
    fetch(
      `${env.REACT_APP_PROXY_BASE_URL}/practitioner`, request
    )
      .then((res) => res.json())
      .then((res) => {
        setPractitioners(res.Practitioners);
      })
      .catch((err) => console.log("Practitioners fetch error " + err));
  }, []);
  return (
    <Grid container justifyContent={"center"} spacing={3}>
      {/* Rappel */}
      <ChoiceHistory page={page} setPage={setPage} />

      {/* Choix du praticien */}
      <Grid item order={{ xs: 2, md: 1 }} xs={12} md={6} mt={5}>
        <Grid container justifyContent="center" direction="column" spacing={2}>
          {/* Titre */}
          <Grid item xs={12}>
            <Typography align="center" variant="h4">
              Choisissez votre praticien
            </Typography>
          </Grid>
          {/* Cartes des praticiens dans ce lieu et avec cette competence */}
          {practitioners === undefined ? (
            <Grid item xs={12}>
              <CircularProgress />
            </Grid>
          ) : (
            practitioners?.map((data) => (
              <Grid
                key={data.ID}
                container
                item
                direction="column"
                alignContent="center"
                xs={12}
                sm
              >
                <Grid item width="360px">
                  <PractitionerCard setPage={setPage} page={page} data={data} />
                </Grid>
                {/* 1er rendez-vous disponible */}
                <EarlyDate page={page} setPage={setPage} data={data} />
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Practitioner;
